import { List, Tag } from "antd-mobile";
import React, { useContext, useState } from "react";
import { Button, Card, Typography, Grid, Box } from "@mui/material";
import {
  AddCircleOutline,
  Assignment,
  Category,
  PriorityHigh,
} from "@mui/icons-material";
import PsContext from "../../context";
import ViewTasks from "./viewTasks";
import Header from "../header";
import AddTask from "./addTask";
import { MuiModalWindow } from "../../utils";
import ViewTaskCategories from "./viewTaskCategories";

const TaskManagement = () => {
  const context = useContext(PsContext);
  const [showList, setShowList] = useState(false);
  const [showCategory, setShowCategory] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);

  // Conditional Rendering: if no access, show the task list directly
  if (!context.allowedAccess("mob_allow_task_management", "action_create")) {
    return (
      <>
        <Header backAction={true} title="Task Management" />
        <div className="container">
          <Card className="mb-2">
            <div className="py-md-3"></div>
            <div className="container-sm" data-aos="zoom-in">
              <ViewTasks />
            </div>
          </Card>
        </div>
      </>
    );
  }

  const dashboardItems = [
    {
      title: "Manage Tasks",
      icon: <Assignment fontSize="large" style={{ color: "white" }} />,
      bgColor: "#4caf50",
      action: () => setShowList(true),
    },
    {
      title: "Manage Task Categories",
      icon: <Category fontSize="large" style={{ color: "white" }} />,
      bgColor: "#2196f3",
      action: () => setShowCategory(true),
    },
    {
      title: "Manage Priorities",
      icon: <PriorityHigh fontSize="large" style={{ color: "white" }} />,
      bgColor: "#f44336",
      action: () => alert("Navigating to Manage Priorities"),
    },
    {
      title: "Add Task",
      icon: <AddCircleOutline fontSize="large" style={{ color: "white" }} />,
      bgColor: "#ff9800",
      action: () => setShowAddModal(true),
    },
  ];

  return (
    <>
      <Header backAction={true} title="Task Management" />
      <div className="container-sm">
        <Box p={2}>
          {showList ? (
            <ViewTasks goBackToDashboard={() => setShowList(false)} />
          ) : showCategory ? (
            <ViewTaskCategories
              goBackToDashboard={() => setShowCategory(false)}
            />
          ) : (
            <Grid container spacing={3}>
              {dashboardItems.map((item, index) => (
                <Grid item xs={6} sm={6} md={3} key={index}>
                  <Card
                    elevation={3}
                    onClick={item.action}
                    className="border-0"
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      cursor: "pointer",
                      backgroundColor: item.bgColor,
                      borderRadius: "15px",
                      height: "150px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    data-aos="zoom-in"
                  >
                    <Box>
                      {item.icon}
                      <Typography
                        variant="subtitle1"
                        style={{ color: "white" }}
                      >
                        {item.title}
                      </Typography>
                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      </div>
      <MuiModalWindow
        open={showAddModal}
        onClose={(e) => setShowAddModal(false)}
        title="Add Task"
      >
        <AddTask
          onSuccess={(e) => {
            setShowAddModal(false);
          }}
        />
      </MuiModalWindow>
    </>
  );
};

export default TaskManagement;
